import { Flex, Heading, Text } from '@chakra-ui/react';
import useTranslation from 'next-translate/useTranslation';
import { BiDotsVerticalRounded } from 'react-icons/bi';
import { configFile } from '@/config';
import Ativity from './Ativity';

export default function AgileMethods() {
  const { t } = useTranslation('services');

  return (
    <Flex
      direction="column"
      maxWidth="1216px"
      margin="0 auto"
      width={{ base: '90%', lg: '100%' }}
      mb="32px"
      gap="72px"
      pt={{ base: '40px', lg: '72px' }}
      pb={{ base: '40px', lg: '72px' }}
    >
      <Flex direction="column" alignItems="center" justifyContent="center" gap="16px">
        <Heading
          as="h2"
          width="90%"
          fontSize={{ base: '36px', lg: '48px' }}
          lineHeight={{ base: '40px', lg: '48px' }}
          fontWeight="800"
          textAlign="center"
          color="blue.900"
          ml={{ base: '0', lg: '0' }}
        >
          {t('seoConsulting.agileMethods.title')}
        </Heading>
        <Text fontSize="16px" lineHeight="24px" color="gray.600" textAlign="center" w={{ base: 'auto', lg: '834px' }}>
          {t('seoConsulting.agileMethods.description')}
        </Text>
      </Flex>
      <Flex
        bgColor={configFile.tertiaryAccentColor}
        gap="16px"
        p={{ base: '24px', lg: '31px' }}
        borderRadius="16px"
        border="1px solid #EDF2F7"
        justifyContent="center"
      >
        <Flex p="24px 16px" bgColor="gray.200" gap="16px" borderRadius="16px" w="375px" direction="column">
          <Flex alignItems="center" justifyContent="space-between">
            <Text fontWeight="600">{t('seoConsulting.agileMethods.backlog')}</Text>
            <BiDotsVerticalRounded />
          </Flex>
          <Ativity />
          <Ativity />
          <Ativity />
        </Flex>
        <Flex
          p="24px 16px"
          bgColor="gray.200"
          gap="16px"
          borderRadius="16px"
          w="375px"
          direction="column"
          display={{ base: 'none', lg: 'flex' }}
        >
          <Flex alignItems="center" justifyContent="space-between">
            <Text fontWeight="600">{t('seoConsulting.agileMethods.inProgress')}</Text>
            <BiDotsVerticalRounded />
          </Flex>
          <Ativity />
        </Flex>
        <Flex
          p="24px 16px"
          bgColor="gray.200"
          gap="16px"
          borderRadius="16px"
          w="375px"
          direction="column"
          display={{ base: 'none', lg: 'flex' }}
        >
          <Flex alignItems="center" justifyContent="space-between">
            <Text fontWeight="600">{t('seoConsulting.agileMethods.done')}</Text>
            <BiDotsVerticalRounded />
          </Flex>
          <Ativity />
        </Flex>
      </Flex>
    </Flex>
  );
}
